export const saleOfferWrapper = {
  background: "#252540",
  width: "23rem",
  borderRadius: "0 2rem 2rem 0",
};

export const saleValueStyle = {
  fontWeight: 500,
  borderRadius: "2rem",
  background: "#ffffff",
  padding: ".5rem .8rem",
};

export const salePromoTextStyle = {
  background: "#252540",
  color: "#ffffff",
  padding: ".5rem 0.8rem .5rem 1rem",
};
